import { render, staticRenderFns } from "./DeleteValidationsModal.vue?vue&type=template&id=49f966ec&"
import script from "./DeleteValidationsModal.vue?vue&type=script&lang=js&"
export * from "./DeleteValidationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports